import React, { useEffect } from "react";
import "./Skills.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Skills = () => {

        useEffect(() => {
          AOS.init();
        }, []);
        return  (
            <>
              <div id="skills" className="skill_body">
                <div className="heading">
                  <div data-aos="fade-up" data-aos-delay="50" className="skillhead1">MY SKILLS</div>
                  <div data-aos="fade-up" data-aos-delay="150" className="skillhead2">I LOVE TO BUILD NEW THINGS</div>
                </div>
                <div className="stack_body">
                  <div className="stack sk1">
                    <div data-aos="fade-right" data-aos-delay="400" className="head_name">Languages/Libraries</div>
                    <div className="upper">
                      <div data-aos="fade-right" data-aos-delay="600" className="sk c"/>
                      <div data-aos="fade-right" data-aos-delay="500" className="sk c__"/>
                      <div data-aos="fade-right" data-aos-delay="400" className="sk html"/>
                      <div data-aos="fade-right" data-aos-delay="300" className="sk css" />
                    </div>
                    <div className="upper">
                      <div data-aos="fade-right" data-aos-delay="400" className="sk js"></div>
                      <div data-aos="fade-right" data-aos-delay="300" className="sk react"></div>
                      <div data-aos="fade-right" data-aos-delay="200" className="sk node"></div>
                    </div>
                  </div>
                  <div className="stack sk2">
                    <div data-aos="fade-left" data-aos-delay="400" className="head_name">Tools</div>
                    <div className="upper">
                      <div data-aos="fade-left" data-aos-delay="300" className="sk vs"/>
                      <div data-aos="fade-left" data-aos-delay="400" className="sk figma" />
                      <div data-aos="fade-left" data-aos-delay="500" className="sk git"/>
                      <div data-aos="fade-left" data-aos-delay="600" className="sk boot"/>
                    </div>
                    <div className="upper">
                      <div data-aos="fade-left" data-aos-delay="200" className="btm_sk sk postman"/>
                      <div data-aos="fade-left" data-aos-delay="300" className="btm_sk sk docker"/>
                      <div data-aos="fade-left" data-aos-delay="400" className="btm_sk sk linux"/>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
};

export default Skills;
